function doRegister() {
  const allowPushNotifications = localStorage.getItem('allowPushNotifications') === 'true';
  
  if (!allowPushNotifications) {
    return;
  }

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
      };

      if (Notification.permission !== 'granted') {
        Notification.requestPermission().then((permission) => {
          console.log('Notification permission:', permission);
          if (permission !== 'granted') {
            console.warn('Notification permission denied. Notifications will not work.');
          }
        });
      }
      
      const refreshRate = localStorage.getItem('refreshRate');
      if (refreshRate && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'SET_REFRESH_RATE',
          refreshRate: parseInt(refreshRate, 10)
        });
      }
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

export function register() {
  if ('serviceWorker' in navigator) {
    if (document.readyState === 'complete') {
      doRegister();
    } else {
      window.addEventListener('load', doRegister);
    }

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'GET_AUTH_DATA') {
        const accessToken = localStorage.getItem('access_token');
        const userDetails = localStorage.getItem('user_details');
        
        event.ports[0].postMessage({
          accessToken: accessToken,
          userDetails: userDetails ? JSON.parse(userDetails) : null
        });
      }
      
      if (event.data && event.data.type === 'PLAY_NOTIFICATION_SOUND') {
        try {
          const audio = new Audio(event.data.soundFile);
          audio.volume = 1.0;
          audio.play()
            .catch((error) => console.error('Failed to play notification sound:', error));
        } catch (error) {
          console.error('Error creating audio:', error);
        }
      }
      
      if (event.data && event.data.type === 'RELOAD_PAGE') {
        window.location.reload();
      }
      
      if (event.data && event.data.type === 'NAVIGATE_AND_RELOAD') {
        window.location.href = event.data.url;
      }
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'STOP_POLLING'
      });
    }
    
    navigator.serviceWorker.ready
      .then((registration) => {
        return registration.unregister();
      })
      .then(() => {
        console.log('Service Worker: Successfully unregistered');
      })
      .catch((error) => {
        console.error('Service Worker: Unregister error:', error.message);
      });
  }
}

export function setCookie(name, value, days = 365) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

export function syncDataToServiceWorker() {
  const accessToken = localStorage.getItem('access_token');
  const userDetails = localStorage.getItem('user_details');
  const allowPushNotifications = localStorage.getItem('allowPushNotifications') === 'true';
  
  if (!allowPushNotifications) {
    unregister();
    return;
  }

  if (accessToken) {
    setCookie('access_token', accessToken);
  }

  if (userDetails) {
    setCookie('user_details', userDetails);
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (!registration) {
        register();
        
        navigator.serviceWorker.ready.then(() => {
          const waitForController = () => {
            if (navigator.serviceWorker.controller) {
              const refreshRate = localStorage.getItem('refreshRate');
              
              navigator.serviceWorker.controller.postMessage({
                type: 'SET_ACCESS_TOKEN',
                token: accessToken
              });
              
              if (refreshRate) {
                navigator.serviceWorker.controller.postMessage({
                  type: 'SET_REFRESH_RATE',
                  refreshRate: parseInt(refreshRate, 10)
                });
              }
            } else {
              setTimeout(waitForController, 100);
            }
          };
          
          waitForController();
        });
      } else {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({
            type: 'SET_ACCESS_TOKEN',
            token: accessToken
          });
          
          const refreshRate = localStorage.getItem('refreshRate');
          if (refreshRate) {
            navigator.serviceWorker.controller.postMessage({
              type: 'SET_REFRESH_RATE',
              refreshRate: parseInt(refreshRate, 10)
            });
          }
        }
      }
    });
  }
}
